<template>
  <link v-if="tenantId === tenantMap.hikvision" rel="shortcut icon" href="/favicon.ico">
  <link v-else-if="tenantId === tenantMap.micro" rel="shortcut icon" href="/microtech/favicon.ico">
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import { getTenantMap } from '@/utils'
import { useStoreHooks } from '@/store/hook'

export default defineComponent({
  setup () {
    const { state: storeState } = useStoreHooks()
    return {
      tenantId: computed(() => storeState.global.tenantId),
      tenantMap: getTenantMap()
    }
  }
})
</script>
